module.exports = __webpack_public_path__ + "img/3.31_Russian_road_sign.4bbada0b.svg";